import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";
import { Subsidiary, CashSystem } from "../types/subsidiaries";
import _ from "lodash";

export function subsidiaryList(state: Subsidiary[] = [], action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_SUBSIDIARIES_SUCCESS:
            return action.payload.subsidiaries.results;
        default:
            return state;
    }
}

/* export function cashSystems(state: CashSystem[] = [], action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_CASH_SYSTEMS_SUCCESS:
            return action.payload.cash_systems.results;
        default:
            return state;
    }
} */

export function coreVersions(state: string[] = [], action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_CORE_VERSIONS_SUCCESS:
            return _.orderBy(
                action.payload.core_versions.results,
                ["version"],
                ["asc"]
            );
        default:
            return state;
    }
}

export function timezones(state: string[] = [], action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_TIMEZONES_SUCCESS:
            return action.payload.timezones.results;
        default:
            return state;
    }
}

export function dynamicHalls(state: string[] = [], action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_DYNAMIC_HALL_SUCCESS:
            return action.payload.halls.value;
        default:
            return state;
    }
}

export function dynamicHallInfo(state: string[] = [], action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_DYNAMIC_HALL_INFO_SUCCESS:
            return action.payload.hall.value;
        case HallsActionTypes.CLEAR_DYNAMIC_HALL_INFO:
            return [];
        default:
            return state;
    }
}

export function subsidiaryLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_SUBSIDIARIES:
            return true;
        case HallsActionTypes.GET_SUBSIDIARIES_SUCCESS:
        case HallsActionTypes.GET_SUBSIDIARIES_FAIL:
            return false;
        default:
            return state;
    }
}

export function timezonesLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_TIMEZONES:
            return true;
        case HallsActionTypes.GET_TIMEZONES_SUCCESS:
        case HallsActionTypes.GET_TIMEZONES_FAIL:
            return false;
        default:
            return state;
    }
}

export function dynamicHallsLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_DYNAMIC_HALL:
            return true;
        case HallsActionTypes.GET_DYNAMIC_HALL_SUCCESS:
        case HallsActionTypes.GET_DYNAMIC_HALL_FAIL:
            return false;
        default:
            return state;
    }
}

export function dynamicHallInfoLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case HallsActionTypes.GET_DYNAMIC_HALL_INFO:
            return true;
        case HallsActionTypes.GET_DYNAMIC_HALL_INFO_SUCCESS:
        case HallsActionTypes.GET_DYNAMIC_HALL_INFO_FAIL:
            return false;
        default:
            return state;
    }
}
